import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";
import Switch from "react-switch";

class BecaFamilia1 extends Component {
    state = {
        chkAP: this.props.datos.chkAP.value,
        chkUP: this.props.datos.chkUP.value,
        chkCony: this.props.datos.chkCony.value,
        chkHer: this.props.datos.chkHer.value,
        chkNor: this.props.datos.chkNor.value,
        chkDis: this.props.datos.chkDis.value,
        nombre1: this.props.datos.nombre1.text,
        nombre2: this.props.datos.nombre2.text,
        cedula: this.props.datos.cedula.text,
        apellido1: this.props.datos.apellido1.text,
        apellido2: this.props.datos.apellido2.text,
        tlf: this.props.datos.tlf.text,
        instruccion: this.props.datos.instruccion.text,
        ocupacion: this.props.datos.ocupacion.text,
        trabajo: this.props.datos.trabajo.text,
        cargo: this.props.datos.cargo.text,
        direccion: this.props.datos.direccion.text,
        tlf2: this.props.datos.tlf2.text
    }

    cambiaSwitch = (tipo) => () => {
        let campo = { value: !this.state[tipo], errMess: "" }
        this.props.funcion(tipo, campo, "datosBecaFamilia1")
        this.setState({
            [tipo]: !this.state[tipo]
        })
    }

    cambiaSwitchSF = () => {
        let campochkNor = { value: !this.state.chkNor, errMess: "" }
        let campochkDis = { value: !this.state.chkDis, errMess: "" }

        this.props.funcion("chkNor", campochkNor, "datosBecaFamilia1")
        this.props.funcion("chkDis", campochkDis, "datosBecaFamilia1")
        this.setState({
            chkNor: !this.state.chkNor,
            chkDis: !this.state.chkDis
        })
    }

    cambiaValor = (prop, err) => (e) => {
        let campo ={
            text: e.target.value,
            errMess: err
        }
        this.props.funcion(prop, campo, "datosBecaFamilia1")
    }

    cambiaState = (prop) => (e) => {
        this.setState({
            [prop]: (e.target.value).toUpperCase()
        })
    }

    render() {
        let { chkAP, chkUP, chkCony, chkHer, chkNor, chkDis, nombre1, nombre2, cedula, apellido1, apellido2, tlf,
            instruccion, ocupacion, trabajo, cargo, direccion, tlf2 } = this.state;

        return (
            <React.Fragment>
                <div className="custom-alert-info custom-mt-10">Familia</div>
                <div style={{paddingRight: 10, paddingLeft: 20}}>
                    <Row>
                        <Col md={8}>
                            <div className="custom-alert-warning custom-mt-10">Núcleo Familiar</div>
                            <Row>
                                <Col md={3} className="custom-mt-10" align="center">
                                    <Switch height={12} width={24} onChange={this.cambiaSwitch("chkAP")} checked={chkAP} />
                                    <div style={{fontSize: 10}}>Ambos Padres</div>
                                </Col>
                                <Col md={3} className="custom-mt-10" style={{fontSize: 10}} align="center">
                                    <Switch height={12} width={24} onChange={this.cambiaSwitch("chkUP")} checked={chkUP} />
                                    <div style={{fontSize: 10}}>Un Solo Padre</div>
                                </Col>
                                <Col md={3} className="custom-mt-10" style={{fontSize: 10}} align="center">
                                    <Switch height={12} width={24} onChange={this.cambiaSwitch("chkCony")} checked={chkCony} />
                                    <div>Cónyuge o Pareja</div>
                                </Col>
                                <Col md={3} className="custom-mt-10" style={{fontSize: 10}} align="center">
                                    <Switch height={12} width={24} onChange={this.cambiaSwitch("chkHer")} checked={chkHer} />
                                    <div>Hermanos</div>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={4}>
                            <div className="custom-alert-warning custom-mt-10">Situación Familiar</div>
                            <Row>
                                <Col md={6} className="custom-mt-10" style={{fontSize: 10}} align="center">
                                    <Switch height={12} width={24} onChange={this.cambiaSwitchSF} checked={chkNor} />
                                    <div>Normal</div>
                                </Col>
                                <Col md={6} className="custom-mt-10" style={{fontSize: 10}} align="center">
                                    <Switch height={12} width={24} onChange={this.cambiaSwitchSF} checked={chkDis} />
                                    <div>Disfuncional</div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <div className="custom-alert-warning custom-mt-10">Datos del Cónyuge o Pareja</div>
                    <Row>
                        <Col md={5} className="custom-mt-10">
                            <div className="text-muted">Primer Nombre</div>
                            <input type="text" value={nombre1} onChange={this.cambiaState("nombre1")} onBlur={this.cambiaValor("nombre1", "")} className="form-control" placeholder="Primer Nombre"/>
                        </Col>
                        <Col md={5} className="custom-mt-10">
                            <div className="text-muted">Segundo Nombre</div>
                            <input type="text" value={nombre2} onChange={this.cambiaState("nombre2")} onBlur={this.cambiaValor("nombre2", "")} className="form-control" placeholder="Segundo Nombre"/>
                        </Col>
                        <Col md={2} className="custom-mt-10">
                            <div className="text-muted">Cédula</div>
                            <input type="text" value={cedula} onChange={this.cambiaState("cedula")} onBlur={this.cambiaValor("cedula", "")} className="form-control" placeholder="Cédula"/>
                        </Col>
                        <Col md={5} className="custom-mt-10">
                            <div className="text-muted">Primer Apellido</div>
                            <input type="text" value={apellido1} onChange={this.cambiaState("apellido1")} onBlur={this.cambiaValor("apellido1", "")} className="form-control" placeholder="Primer Apellido"/>
                        </Col>
                        <Col md={5} className="custom-mt-10">
                            <div className="text-muted">Segundo Apellido</div>
                            <input type="text" value={apellido2} onChange={this.cambiaState("apellido2")} onBlur={this.cambiaValor("apellido2", "")} className="form-control" placeholder="Segundo Apellido"/>
                        </Col>
                        <Col md={2} className="custom-mt-10">
                            <div className="text-muted">Teléfono</div>
                            <input type="text" value={tlf} onChange={this.cambiaState("tlf")} onBlur={this.cambiaValor("tlf", "")} className="form-control" placeholder="Ej.: 04121234567"/>
                        </Col>
                        <Col md={3} className="custom-mt-10">
                            <div className="text-muted">Grado de Instrucción</div>
                            <input type="text" value={instruccion} onChange={this.cambiaState("instruccion")} onBlur={this.cambiaValor("instruccion", "")} className="form-control" placeholder="Ej.: Bachiller"/>
                        </Col>
                        <Col md={3} className="custom-mt-10">
                            <div className="text-muted">Ocupación</div>
                            <input type="text" value={ocupacion} onChange={this.cambiaState("ocupacion")} onBlur={this.cambiaValor("ocupacion", "")} className="form-control" placeholder="Ej.: Obrero"/>
                        </Col>
                        <Col md={3} className="custom-mt-10">
                            <div className="text-muted">Lugar de Tabajo</div>
                            <input type="text" value={trabajo} onChange={this.cambiaState("trabajo")} onBlur={this.cambiaValor("trabajo", "")} className="form-control" placeholder="Lug. Trabajo"/>
                        </Col>
                        <Col md={3} className="custom-mt-10">
                            <div className="text-muted">Cargo</div>
                            <input type="text" value={cargo} onChange={this.cambiaState("cargo")} onBlur={this.cambiaValor("cargo", "")} className="form-control" placeholder="Cargo"/>
                        </Col>
                        <Col md={9} className="custom-mt-10">
                            <div className="text-muted">Dirección</div>
                            <input type="text" value={direccion} onChange={this.cambiaState("direccion")} onBlur={this.cambiaValor("direccion", "")} className="form-control" placeholder="Dirección de lugar de trabajo"/>
                        </Col>
                        <Col md={3} className="custom-mt-10">
                            <div className="text-muted">Teléfono Ofic.</div>
                            <input type="text" value={tlf2} onChange={this.cambiaState("tlf2")} onBlur={this.cambiaValor("tlf2", "")} className="form-control" placeholder="Teléfono"/>
                        </Col>
                    </Row>
                </div>
            </React.Fragment>
        );
    }
}
 
export default BecaFamilia1;


// WEBPACK FOOTER //
// ./src/views/EstSolicitudes/BecaFamilia1.jsx